export default __webpack_public_path__ + "static/media/menu.eb5b9c87.svg";